import { Link } from '@inertiajs/react'
import { Badge } from '@/shared/ui/badge'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/shared/ui/table'
import { t } from '@/shared/lib/i18n'
import { departmentSignoffChainPath } from '@/shared/lib/routes'
import { RETURN_TO_SIGNOFF_MONITORING } from '@/shared/lib/signoff-chain-return-to'

export interface DepartmentChainRow {
  departmentId: number
  departmentName: string
  siteName: string | null
  hasChain: boolean
  hasSigners: boolean
}

interface DepartmentChainStatusTableProps {
  departmentChainStatus: DepartmentChainRow[]
}

const DepartmentChainStatusTable = ({ departmentChainStatus }: DepartmentChainStatusTableProps) => {
  return (
    <div className="space-y-3">
      <h2 className="text-lg font-semibold">
        {t('admin.signoffMonitoring.chainStatus.sectionTitle')}
      </h2>
      <div className="rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{t('admin.signoffMonitoring.chainStatus.columns.department')}</TableHead>
              <TableHead>{t('admin.signoffMonitoring.chainStatus.columns.chainStatus')}</TableHead>
              <TableHead className="w-[1%]">
                {t('admin.signoffMonitoring.chainStatus.columns.actions')}
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {departmentChainStatus.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} className="text-center text-muted-foreground">
                  {t('admin.signoffMonitoring.chainStatus.emptyState')}
                </TableCell>
              </TableRow>
            ) : (
              departmentChainStatus.map((row) => {
                const isFullyConfigured = row.hasChain && row.hasSigners

                return (
                  <TableRow key={row.departmentId}>
                    <TableCell className="font-medium">
                      {row.departmentName}
                      {row.siteName && (
                        <p className="text-sm font-normal text-muted-foreground">{row.siteName}</p>
                      )}
                    </TableCell>
                    <TableCell>
                      {isFullyConfigured ? (
                        <Badge variant="default">
                          {t('admin.signoffMonitoring.chainStatus.configured')}
                        </Badge>
                      ) : (
                        <Badge variant="destructive">
                          {t('admin.signoffMonitoring.chainStatus.notConfigured')}
                        </Badge>
                      )}
                    </TableCell>
                    <TableCell>
                      {!isFullyConfigured && (
                        <Link
                          href={departmentSignoffChainPath(row.departmentId, {
                            return_to: RETURN_TO_SIGNOFF_MONITORING,
                          })}
                          className="whitespace-nowrap text-xs text-primary hover:underline"
                        >
                          {t('admin.signoffMonitoring.chainStatus.configureLink')}
                        </Link>
                      )}
                    </TableCell>
                  </TableRow>
                )
              })
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}

export default DepartmentChainStatusTable
